import React from 'react';
import PropTypes from 'prop-types';
import {
  Label,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import {
  formatBytes,
  getFileExtension,
  getFileAccessIcon,
  getFileAccessText,
  getImageResolution,
} from '../../../helpers/Files';

import FileStatus from '../../File/Status';
import UploadFileThumbnail from '../../Upload/FileThumbnail';

import ErrorBoundary from '../../ErrorBoundary';

const DuplicateFileListItem = ({ file }) => {
  const intl = useIntl();

  const extension = getFileExtension(file);
  const resolution = getImageResolution(file);

  return (
    <ErrorBoundary>
      <li key={file.uuid} className="merge-files-file">
        <Label className="merge-files-file-wrapper" htmlFor={`merge-files-file-${file.uuid}`}>
          <UploadFileThumbnail
            completed={true}
            error={false}
            file={file}
          />
          <div className="merge-files-file-body">
            <h6 className="merge-files-file-title">
              {file.display_name}
              <FileStatus
                file={file}
              />
            </h6>
            <div className="merge-files-file-details file-details">
              <div>
                <span className="file-access">
                  <i className={`fas ${getFileAccessIcon(file)}`} id={`MergeFileAccessTooltip-${file.uuid}`} />
                  <UncontrolledTooltip fade={false} placement="bottom" target={`MergeFileAccessTooltip-${file.uuid}`}>
                    {getFileAccessText(file, intl)}
                  </UncontrolledTooltip>
                </span>
                {resolution && (
                  <span className="file-resolution">
                    {resolution}
                  </span>
                )}
                {extension && (
                  <span className="file-extension">
                    {extension}
                  </span>
                )}
                <span className="file-size">
                  {formatBytes(file.size)}
                </span>
              </div>
            </div>
          </div>
        </Label>
      </li>
    </ErrorBoundary>
  );
};

DuplicateFileListItem.propTypes = {
  file: PropTypes.object.isRequired,
};

export default DuplicateFileListItem;
